import styles from './InnerLink.module.scss';
import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useHierarchyContext } from '../../hooks/useHierarchyContext';
import { collectionData } from '../../configs';
import { useSEOKeywords } from '../../hooks/useSEOKeywords';
import { SEARCH_PARAM_KEY_TYPE } from '../../constants/searchParamKeys';
export const InnerLink = () => {
    const [searchParams] = useSearchParams();
    const { handle, medium } = useParams();
    const { objects } = useHierarchyContext();
    const { kw1, kw3 } = useSEOKeywords();
    const type = searchParams.get(SEARCH_PARAM_KEY_TYPE);
    if (handle === undefined || type === null)
        return null;
    const title = objects[handle]?.name ?? collectionData.title;
    let pathname = `/collections/${handle}`;
    if (medium !== undefined) {
        pathname += `/${medium}`;
    }
    return (React.createElement("p", { className: `text:center ${styles.link}` },
        "Looking for additional ",
        title,
        " ",
        kw1,
        " ideas? Select from ",
        React.createElement(Link, { to: { pathname }, className: "text:underline" }, `inspiring ${title} ${kw3} here >>`)));
};
